export class Tenant {
  name: string;
  description: string;
  address: string;
  address2: string;
  city: string;
  country: string;
  email: string;
  phone: string | object;
  region: string;
  zip: string;
  exchange: string;
  entryDate: number;
  expirationDate: number;
  uuid: string;
}
